/*
 * lists taken from https://github.com/aceakash/project-name-generator
 *
 * Copyright (c) 2016, Akash Kurdekar <akashkurdekar@gmail.com>
 *
 * Permission to use, copy, modify, and/or distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 */

export const ADJECTIVES = [
  'Abandoned',
  'Abashed',
  'Aberrant',
  'Abiding',
  'Abject',
  'Ablaze',
  'Able',
  'Abounding',
  'Abrasive',
  'Abrupt',
  'Absent',
  'Absorbed',
  'Absorbing',
  'Abstracted',
  'Absurd',
  'Abundant',
  'Acceptable',
  'Accessible',
  'Accidental',
  'Accurate',
  'Acidic',
  'Acoustic',
  'Acrid',
  'Actionable',
  'Active',
  'Actual',
  'Adamant',
  'Adaptable',
  'Adept',
  'Adhesive',
  'Adjoining',
  'Adorable',
  'Adroit',
  'Adventurous',
  'Affable',
  'Affectionate',
  'Afraid',
  'Aggressive',
  'Agile',
  'Agonizing',
  'Agreeable',
  'Airy',
  'Alert',
  'Alive',
  'Alleged',
  'Alluring',
  'Aloof',
  'Amazing',
  'Ambiguous',
  'Ambitious',
  'Amiable',
  'Ample',
  'Amused',
  'Amusing',
  'Ancient',
  'Angry',
  'Animated',
  'Annoyed',
  'Annoying',
  'Anxious',
  'Apathetic',
  'Apt',
  'Aquatic',
  'Ardent',
  'Aromatic',
  'Arrogant',
  'Ashamed',
  'Aspiring',
  'Assorted',
  'Astonishing',
  'Astute',
  'Attractive',
  'August',
  'Auspicious',
  'Automatic',
  'Available',
  'Average',
  'Avid',
  'Aware',
  'Awesome',
  'Awful',
  'Axiomatic',
  'Bad',
  'Balmy',
  'Barbarous',
  'Bashful',
  'Bawdy',
  'Beautiful',
  'Befitting',
  'Belligerent',
  'Beneficial',
  'Benevolent',
  'Bent',
  'Berserk',
  'Best',
  'Better',
  'Bewildered',
  'Big',
  'Billowing',
  'Billowy',
  'Bitter',
  'Bizarre',
  'Blessed',
  'Bloody',
  'Blue',
  'Blushing',
  'Boiling',
  'Bold',
  'Boorish',
  'Bored',
  'Boring',
  'Boss',
  'Bouncy',
  'Boundless',
  'Brainy',
  'Brash',
  'Brave',
  'Brawny',
  'Breakable',
  'Breezy',
  'Brief',
  'Bright',
  'Brisk',
  'Broad',
  'Broken',
  'Bumpy',
  'Burly',
  'Bustling',
  'Busy',
  'Cagey',
  'Calculating',
  'Callous',
  'Calm',
  'Can',
  'Canny',
  'Capable',
  'Capricious',
  'Cared',
  'Careful',
  'Careless',
  'Caring',
  'Casual',
  'Cautious',
  'Ceaseless',
  'Celestial',
  'Certain',
  'Changeable',
  'Charming',
  'Cheap',
  'Cheerful',
  'Chemical',
  'Chic',
  'Chief',
  'Childlike',
  'Chilly',
  'Chivalrous',
  'Choice',
  'Chosen',
  'Chubby',
  'Chummy',
  'Chunky',
  'Civic',
  'Civil',
  'Clammy',
  'Classy',
  'Clean',
  'Clear',
  'Clever',
  'Cloistered',
  'Close',
  'Closed',
  'Cloudy',
  'Clumsy',
  'Cluttered',
  'Cogent',
  'Coherent',
  'Cold',
  'Colorful',
  'Colossal',
  'Combative',
  'Comfortable',
  'Common',
  'Complete',
  'Complex',
  'Composed',
  'Concerned',
  'Condemned',
  'Confused',
  'Conscious',
  'Cooing',
  'Cool',
  'Cooperative',
  'Coordinated',
  'Cosmic',
  'Courageous',
  'Cowardly',
  'Cozy',
  'Crabby',
  'Craven',
  'Crazy',
  'Creepy',
  'Crooked',
  'Crowded',
  'Cruel',
  'Cuddly',
  'Cultured',
  'Cumbersome',
  'Curious',
  'Curly',
  'Curved',
  'Curvy',
  'Cut',
  'Cute',
  'Cynical',
  'Daffy',
  'Daily',
  'Dainty',
  'Damaged',
  'Damaging',
  'Damp',
  'Dandy',
  'Dangerous',
  'Dapper',
  'Daring',
  'Dark',
  'Dashing',
  'Dazzling',
  'Dead',
  'Deadpan',
  'Deafening',
  'Dear',
  'Debonair',
  'Decent',
  'Decisive',
  'Decorous',
  'Deep',
  'Deeply',
  'Defeated',
  'Defective',
  'Defiant',
  'Deft',
  'Delicate',
  'Delicious',
  'Delightful',
  'Delirious',
  'Deluxe',
  'Demonic',
  'Dependent',
  'Deranged',
  'Descriptive',
  'Deserted',
  'Detailed',
  'Determined',
  'Devilish',
  'Devout',
  'Didactic',
  'Different',
  'Difficult',
  'Diligent',
  'Direct',
  'Direful',
  'Dirty',
  'Disagreeable',
  'Disastrous',
  'Discreet',
  'Disgusted',
  'Disgusting',
  'Disillusioned',
  'Dispensable',
  'Distinct',
  'Disturbed',
  'Divergent',
  'Divine',
  'Dizzy',
  'Domineering',
  'Doted',
  'Doting',
  'Doubtful',
  'Drab',
  'Draconian',
  'Dramatic',
  'Dreamy',
  'Dreary',
  'Driven',
  'Dry',
  'Dull',
  'Dusty',
  'Dynamic',
  'Dysfunctional',
  'Eager',
  'Early',
  'Earsplitting',
  'Earthy',
  'Easy',
  'Eatable',
  'Economic',
  'Educated',
  'Efficacious',
  'Efficient',
  'Eight',
  'Elastic',
  'Elated',
  'Electric',
  'Elegant',
  'Elfin',
  'Elite',
  'Embarrassed',
  'Eminent',
  'Empty',
  'Enchanted',
  'Enchanting',
  'Encouraging',
  'End',
  'Endurable',
  'Energetic',
  'Energized',
  'Enigmatic',
  'Enormous',
  'Entertaining',
  'Enthusiastic',
  'Envious',
  'Equable',
  'Equal',
  'Erect',
  'Erratic',
  'Ethereal',
  'Evanescent',
  'Evasive',
  'Even',
  'Exact',
  'Excellent',
  'Excited',
  'Exciting',
  'Exclusive',
  'Exotic',
  'Expensive',
  'Expert',
  'Exuberant',
  'Exultant',
  'Fabulous',
  'Faded',
  'Faint',
  'Fair',
  'Faithful',
  'Fallacious',
  'False',
  'Famed',
  'Familiar',
  'Famous',
  'Fanatical',
  'Fancy',
  'Fantastic',
  'Far',
  'Fascinated',
  'Fast',
  'Faulty',
  'Fearful',
  'Fearless',
  'Feigned',
  'Fertile',
  'Festive',
  'Few',
  'Fierce',
  'Fiery',
  'Filthy',
  'Fine',
  'Finicky',
  'First',
  'Fit',
  'Fixed',
  'Flagrant',
  'Flaky',
  'Flashy',
  'Flat',
  'Flawless',
  'Fleet',
  'Flimsy',
  'Flippant',
  'Flowery',
  'Flowing',
  'Fluent',
  'Fluffy',
  'Fluttering',
  'Flying',
  'Foamy',
  'Fond',
  'Foolish',
  'For',
  'Foregoing',
  'Forgetful',
  'Forlorn',
  'Fortunate',
  'Fragile',
  'Frail',
  'Frank',
  'Frantic',
  'Free',
  'Freezing',
  'Frequent',
  'Fresh',
  'Fretful',
  'Friendly',
  'Frightened',
  'Frightening',
  'Full',
  'Fumbling',
  'Fun',
  'Functional',
  'Funny',
  'Furry',
  'Furtive',
  'Fuscia',
  'Future',
  'Futuristic',
  'Fuzzy',
  'Gabby',
  'Gainful',
  'Gamy',
  'Gaping',
  'Garrulous',
  'Gas',
  'Gaudy',
  'General',
  'Genial',
  'Gentle',
  'Giant',
  'Giddy',
  'Gifted',
  'Gigantic',
  'Giving',
  'Glad',
  'Glamorous',
  'Gleaming',
  'Glib',
  'Glistening',
  'Glorious',
  'Glossy',
  'Gnarly',
  'Godly',
  'Gold',
  'Golden',
  'Good',
  'Goodly',
  'Goofy',
  'Gorgeous',
  'Graceful',
  'Grand',
  'Grandiose',
  'Grateful',
  'Gratis',
  'Gray',
  'Greasy',
  'Great',
  'Greedy',
  'Green',
  'Grey',
  'Grieving',
  'Groovy',
  'Grotesque',
  'Grouchy',
  'Grubby',
  'Gruesome',
  'Grumpy',
  'Guarded',
  'Guided',
  'Guiltless',
  'Gullible',
  'Gusty',
  'Gutsy',
  'Guttural',
  'Habitual',
  'Half',
  'Hallowed',
  'Haloed',
  'Halting',
  'Handsome',
  'Handsomely',
  'Handy',
  'Hanging',
  'Hapless',
  'Happy',
  'Hard',
  'Hardy',
  'Harmonious',
  'Harsh',
  'Heady',
  'Healthy',
  'Heartbreaking',
  'Hearty',
  'Heavenly',
  'Heavy',
  'Hellish',
  'Helpful',
  'Helpless',
  'Heroic',
  'Hesitant',
  'Hideous',
  'High',
  'Highfalutin',
  'Hilarious',
  'Hip',
  'Hissing',
  'Historical',
  'Holistic',
  'Hollow',
  'Holy',
  'Homely',
  'Honest',
  'Honorable',
  'Horrible',
  'Hospitable',
  'Hot',
  'Huge',
  'Hulking',
  'Human',
  'Humane',
  'Humble',
  'Humdrum',
  'Humorous',
  'Hungry',
  'Hunky',
  'Hurried',
  'Hurt',
  'Hushed',
  'Husky',
  'Hypnotic',
  'Hysterical',
  'Icky',
  'Icy',
  'Ideal',
  'Ignorant',
  'Ill',
  'Illegal',
  'Illustrious',
  'Imaginary',
  'Immense',
  'Imminent',
  'Immune',
  'Impartial',
  'Imperfect',
  'Impolite',
  'Important',
  'Imported',
  'Impossible',
  'Incandescent',
  'Incompetent',
  'Inconclusive',
  'Incredible',
  'Indigo',
  'Industrious',
  'Inexpensive',
  'Infamous',
  'Innate',
  'Innocent',
  'Inquisitive',
  'Insidious',
  'Instinctive',
  'Intelligent',
  'Interesting',
  'Internal',
  'Invincible',
  'Irate',
  'Itchy',
  'Jaded',
  'Jagged',
  'Jazzed',
  'Jazzy',
  'Jealous',
  'Jittery',
  'Jolly',
  'Jovial',
  'Joyful',
  'Joyous',
  'Jubilant',
  'Judicious',
  'Juicy',
  'Jumbled',
  'Jumpy',
  'Just',
  'Kaput',
  'Keen',
  'Khaki',
  'Kind',
  'Kindhearted',
  'Kindly',
  'Kingly',
  'Knotty',
  'Knowing',
  'Knowledgeable',
  'Known',
  'Labored',
  'Lackadaisical',
  'Lacking',
  'Lame',
  'Lamentable',
  'Languid',
  'Large',
  'Last',
  'Late',
  'Laughable',
  'Lavish',
  'Lawful',
  'Lazy',
  'Lean',
  'Legal',
  'Legit',
  'Lethal',
  'Level',
  'Light',
  'Like',
  'Likeable',
  'Likely',
  'Limber',
  'Limitless',
  'Limping',
  'Literate',
  'Little',
  'Lively',
  'Living',
  'Lonely',
  'Long',
  'Longing',
  'Loose',
  'Lopsided',
  'Loud',
  'Loved',
  'Lovely',
  'Loving',
  'Low',
  'Lowly',
  'Loyal',
  'Lucid',
  'Lucky',
  'Ludicrous',
  'Lumpy',
  'Lush',
  'Luxuriant',
  'Lying',
  'Lyrical',
  'Macabre',
  'Macho',
  'Maddening',
  'Madly',
  'Magenta',
  'Magical',
  'Magnificent',
  'Main',
  'Majestic',
  'Major',
  'Makeshift',
  'Malicious',
  'Mammoth',
  'Maniacal',
  'Many',
  'Marked',
  'Married',
  'Marvelous',
  'Massive',
  'Material',
  'Materialistic',
  'Max',
  'Maxed',
  'Mean',
  'Measly',
  'Meaty',
  'Medical',
  'Meek',
  'Mellow',
  'Melodic',
  'Melted',
  'Merciful',
  'Mere',
  'Merry',
  'Messy',
  'Mighty',
  'Military',
  'Milky',
  'Mindless',
  'Miniature',
  'Minor',
  'Mint',
  'Mirthful',
  'Miscreant',
  'Misty',
  'Mixed',
  'Moaning',
  'Modern',
  'Modest',
  'Moldy',
  'Momentous',
  'Money',
  'Moonlit',
  'Moral',
  'Motionless',
  'Mountainous',
  'Moving',
  'Mucho',
  'Muddled',
  'Mundane',
  'Murky',
  'Mushy',
  'Mute',
  'Mutual',
  'Mysterious',
  'Naive',
  'Nappy',
  'Narrow',
  'Nasty',
  'Native',
  'Natural',
  'Naughty',
  'Nauseating',
  'Near',
  'Neat',
  'Nebulous',
  'Necessary',
  'Needed',
  'Needless',
  'Needy',
  'Neighborly',
  'Nervous',
  'New',
  'Next',
  'Nice',
  'Nifty',
  'Nimble',
  'Nippy',
  'Noble',
  'Noiseless',
  'Noisy',
  'Nonchalant',
  'Nondescript',
  'Nonstop',
  'Normal',
  'Nostalgic',
  'Nosy',
  'Noted',
  'Novel',
  'Noxious',
  'Null',
  'Numberless',
  'Numero',
  'Numerous',
  'Nutritious',
  'Nutty',
  'Oafish',
  'Obedient',
  'Obeisant',
  'Obscene',
  'Obsequious',
  'Observant',
  'Obsolete',
  'Obtainable',
  'Oceanic',
  'Odd',
  'Offbeat',
  'Okay',
  'Omniscient',
  'Onerous',
  'Open',
  'Opposite',
  'Optimal',
  'Orange',
  'Ordinary',
  'Organic',
  'Ossified',
  'Outgoing',
  'Outrageous',
  'Outstanding',
  'Oval',
  'Overconfident',
  'Overjoyed',
  'Overrated',
  'Overt',
  'Overwrought',
  'Pacific',
  'Pale',
  'Paltry',
  'Panicky',
  'Panoramic',
  'Parallel',
  'Parched',
  'Parsimonious',
  'Past',
  'Pastoral',
  'Pathetic',
  'Peaceful',
  'Peachy',
  'Penitent',
  'Peppy',
  'Perfect',
  'Periodic',
  'Permissible',
  'Perpetual',
  'Petite',
  'Phobic',
  'Physical',
  'Picayune',
  'Pink',
  'Piquant',
  'Pithy',
  'Placid',
  'Plain',
  'Plant',
  'Plastic',
  'Plausible',
  'Pleasant',
  'Plucky',
  'Plum',
  'Poetic',
  'Pointless',
  'Poised',
  'Polite',
  'Political',
  'Posh',
  'Possessive',
  'Possible',
  'Potent',
  'Powerful',
  'Precious',
  'Premium',
  'Present',
  'Pretty',
  'Previous',
  'Pricey',
  'Prickly',
  'Prime',
  'Primo',
  'Private',
  'Prized',
  'Pro',
  'Probable',
  'Productive',
  'Profuse',
  'Prompt',
  'Proper',
  'Protective',
  'Proud',
  'Psychedelic',
  'Psychotic',
  'Public',
  'Puffy',
  'Pumped',
  'Punchy',
  'Puny',
  'Pure',
  'Purple',
  'Purring',
  'Pushy',
  'Puzzled',
  'Puzzling',
  'Quack',
  'Quaint',
  'Quarrelsome',
  'Questionable',
  'Quick',
  'Quickest',
  'Quiet',
  'Quirky',
  'Quixotic',
  'Quizzical',
  'Rabid',
  'Racial',
  'Rad',
  'Radioactive',
  'Ragged',
  'Rainy',
  'Rambunctious',
  'Rampant',
  'Rapid',
  'Rare',
  'Raspy',
  'Ratty',
  'Reach',
  'Ready',
  'Real',
  'Rebel',
  'Receptive',
  'Recondite',
  'Red',
  'Redundant',
  'Reflective',
  'Regal',
  'Regular',
  'Relieved',
  'Remarkable',
  'Reminiscent',
  'Repulsive',
  'Resilient',
  'Resolute',
  'Resonant',
  'Responsible',
  'Rhetorical',
  'Rich',
  'Right',
  'Righteous',
  'Rightful',
  'Rigid',
  'Ripe',
  'Ritzy',
  'Roasted',
  'Robust',
  'Romantic',
  'Roomy',
  'Rooted',
  'Rosy',
  'Rotten',
  'Rough',
  'Round',
  'Royal',
  'Ruddy',
  'Rude',
  'Rugged',
  'Rural',
  'Rustic',
  'Ruthless',
  'Sable',
  'Sad',
  'Safe',
  'Salty',
  'Same',
  'Sassy',
  'Satisfying',
  'Saucy',
  'Savory',
  'Savvy',
  'Scandalous',
  'Scarce',
  'Scared',
  'Scary',
  'Scattered',
  'Scenic',
  'Scientific',
  'Scintillating',
  'Scrawny',
  'Screeching',
  'Second',
  'Secret',
  'Secretive',
  'Sedate',
  'Seemly',
  'Selective',
  'Sensitive',
  'Separate',
  'Serene',
  'Serious',
  'Shaggy',
  'Shaky',
  'Shallow',
  'Sharp',
  'Shiny',
  'Shivering',
  'Shocking',
  'Short',
  'Showy',
  'Shrewd',
  'Shrill',
  'Shut',
  'Shy',
  'Sick',
  'Silent',
  'Silky',
  'Silly',
  'Simple',
  'Simplistic',
  'Sincere',
  'Skillful',
  'Skinny',
  'Sleek',
  'Sleepy',
  'Slick',
  'Slim',
  'Slimy',
  'Slippery',
  'Sloppy',
  'Slow',
  'Small',
  'Smart',
  'Smelly',
  'Smiley',
  'Smiling',
  'Smoggy',
  'Smooth',
  'Snappy',
  'Snazzy',
  'Sneaky',
  'Snobbish',
  'Snotty',
  'Snowy',
  'Snugly',
  'Social',
  'Soft',
  'Soggy',
  'Sole',
  'Solid',
  'Solitary',
  'Somber',
  'Sophisticated',
  'Sordid',
  'Sore',
  'Sound',
  'Sour',
  'Spacial',
  'Sparkling',
  'Special',
  'Spectacular',
  'Spicy',
  'Spiffy',
  'Spiky',
  'Spiritual',
  'Spiteful',
  'Splendid',
  'Spooky',
  'Spotless',
  'Spotted',
  'Spotty',
  'Spry',
  'Spurious',
  'Squalid',
  'Square',
  'Squealing',
  'Squeamish',
  'Stable',
  'Staking',
  'Stale',
  'Standing',
  'Star',
  'Stark',
  'Statuesque',
  'Steadfast',
  'Steady',
  'Steep',
  'Stereotyped',
  'Sticky',
  'Stiff',
  'Stimulating',
  'Stingy',
  'Stoic',
  'Stormy',
  'Straight',
  'Strange',
  'Striped',
  'Strong',
  'Stunning',
  'Stupendous',
  'Sturdy',
  'Suave',
  'Subdued',
  'Subsequent',
  'Substantial',
  'Subtle',
  'Successful',
  'Succinct',
  'Sudden',
  'Sulky',
  'Sunny',
  'Sunset',
  'Super',
  'Superb',
  'Superficial',
  'Supreme',
  'Sure',
  'Swank',
  'Swanky',
  'Sweet',
  'Swell',
  'Sweltering',
  'Swift',
  'Symptomatic',
  'Synonymous',
  'Taboo',
  'Tacit',
  'Tacky',
  'Talented',
  'Tall',
  'Tame',
  'Tan',
  'Tangible',
  'Tangy',
  'Tart',
  'Tasteful',
  'Tasteless',
  'Tasty',
  'Tawdry',
  'Teal',
  'Tearful',
  'Tedious',
  'Teeny',
  'Telling',
  'Temporary',
  'Tender',
  'Tense',
  'Tenuous',
  'Terrible',
  'Terrific',
  'Tested',
  'Testy',
  'Thankful',
  'Therapeutic',
  'Thin',
  'Thinkable',
  'Third',
  'Thoughtful',
  'Thoughtless',
  'Threatening',
  'Thriving',
  'Thundering',
  'Tidy',
  'Timely',
  'Tiny',
  'Tired',
  'Tiresome',
  'Toothsome',
  'Top',
  'Tops',
  'Torpid',
  'Tough',
  'Touted',
  'Towering',
  'Tranquil',
  'Trashy',
  'Tremendous',
  'Tricky',
  'Trim',
  'Trite',
  'Tropical',
  'Troubled',
  'Truculent',
  'True',
  'Trusty',
  'Truthful',
  'Try',
  'Typical',
  'Ubiquitous',
  'Ultra',
  'Unable',
  'Unaccountable',
  'Unadvised',
  'Unarmed',
  'Unbecoming',
  'Unbiased',
  'Uncovered',
  'Understood',
  'Undisturbed',
  'Unequal',
  'Unequaled',
  'Uneven',
  'Unhealthy',
  'Uninterested',
  'Unique',
  'United',
  'Unkempt',
  'Unknown',
  'Unnatural',
  'Unruly',
  'Unsightly',
  'Unsuitable',
  'Untidy',
  'Unused',
  'Unusual',
  'Unwavering',
  'Unwieldy',
  'Unwritten',
  'Upbeat',
  'Uplifting',
  'Uppity',
  'Upset',
  'Uptight',
  'Urbane',
  'Usable',
  'Used',
  'Useful',
  'Utmost',
  'Utopian',
  'Utter',
  'Uttermost',
  'Vacuous',
  'Vagabond',
  'Vague',
  'Valid',
  'Valuable',
  'Various',
  'Vast',
  'Vengeful',
  'Venomous',
  'Verdant',
  'Versed',
  'Vestal',
  'Viable',
  'Victorious',
  'Vigorous',
  'Violent',
  'Violet',
  'Vital',
  'Vivacious',
  'Vivid',
  'Vocal',
  'Vogue',
  'Voiceless',
  'Volatile',
  'Voracious',
  'Wacky',
  'Waggish',
  'Waiting',
  'Wakeful',
  'Wandering',
  'Wanted',
  'Wanting',
  'Warlike',
  'Warm',
  'Wary',
  'Wasteful',
  'Watery',
  'Weak',
  'Wealthy',
  'Weary',
  'Wet',
  'Whimsical',
  'Whispering',
  'Whole',
  'Wholesale',
  'Wicked',
  'Wide',
  'Wiggly',
  'Wild',
  'Willing',
  'Windy',
  'Winged',
  'Wired',
  'Wiry',
  'Wise',
  'Wistful',
  'Witty',
  'Woebegone',
  'Wonderful',
  'Wooden',
  'Woozy',
  'Workable',
  'Worried',
  'Worthy',
  'Wrathful',
  'Wretched',
  'Wrong',
  'Wry',
  'Yielding',
  'Young',
  'Youthful',
  'Yummy',
  'Zany',
  'Zealous',
  'Zesty',
  'Zippy',
  'Zonked'
]

export const NOUNS = [
  'account',
  'achiever',
  'acoustics',
  'act',
  'action',
  'activity',
  'actor',
  'addition',
  'adjustment',
  'advertisement',
  'advice',
  'aftermath',
  'afternoon',
  'afterthought',
  'agreement',
  'air',
  'airplane',
  'airport',
  'alarm',
  'amount',
  'amusement',
  'anger',
  'angle',
  'animal',
  'ants',
  'apparatus',
  'apparel',
  'appliance',
  'approval',
  'arch',
  'argument',
  'arithmetic',
  'arm',
  'army',
  'art',
  'attack',
  'attraction',
  'authority',
  'back',
  'badge',
  'bag',
  'bait',
  'balance',
  'ball',
  'base',
  'baseball',
  'basin',
  'basket',
  'basketball',
  'bat',
  'bath',
  'battle',
  'bead',
  'bear',
  'bed',
  'bedroom',
  'beds',
  'bee',
  'beef',
  'beginner',
  'behavior',
  'belief',
  'believe',
  'bell',
  'bells',
  'berry',
  'bike',
  'bikes',
  'bird',
  'birds',
  'birth',
  'birthday',
  'bit',
  'bite',
  'blade',
  'blood',
  'blow',
  'board',
  'boat',
  'bomb',
  'bone',
  'book',
  'books',
  'boot',
  'border',
  'bottle',
  'boundary',
  'box',
  'brake',
  'branch',
  'brass',
  'breath',
  'brick',
  'bridge',
  'bubble',
  'bucket',
  'building',
  'bulb',
  'burst',
  'bushes',
  'business',
  'butter',
  'button',
  'cabbage',
  'cable',
  'cactus',
  'cake',
  'cakes',
  'calculator',
  'calendar',
  'camera',
  'camp',
  'can',
  'cannon',
  'canvas',
  'cap',
  'caption',
  'car',
  'card',
  'care',
  'carpenter',
  'carriage',
  'cars',
  'cart',
  'cast',
  'cat',
  'cats',
  'cattle',
  'cause',
  'cave',
  'celery',
  'cellar',
  'cemetery',
  'cent',
  'chalk',
  'chance',
  'change',
  'channel',
  'cheese',
  'cherries',
  'cherry',
  'chess',
  'chicken',
  'chickens',
  'chin',
  'church',
  'circle',
  'clam',
  'class',
  'cloth',
  'clover',
  'club',
  'coach',
  'coal',
  'coast',
  'coat',
  'cobweb',
  'coil',
  'collar',
  'color',
  'committee',
  'company',
  'comparison',
  'competition',
  'condition',
  'connection',
  'control',
  'cook',
  'copper',
  'corn',
  'cough',
  'country',
  'cover',
  'cow',
  'cows',
  'crack',
  'cracker',
  'crate',
  'crayon',
  'cream',
  'creator',
  'creature',
  'credit',
  'crib',
  'crime',
  'crook',
  'crow',
  'crowd',
  'crown',
  'cub',
  'cup',
  'current',
  'curtain',
  'curve',
  'cushion',
  'day',
  'death',
  'debt',
  'decision',
  'deer',
  'degree',
  'design',
  'desire',
  'desk',
  'destruction',
  'detail',
  'development',
  'digestion',
  'dime',
  'dinner',
  'dinosaurs',
  'direction',
  'dirt',
  'discovery',
  'discussion',
  'distance',
  'distribution',
  'division',
  'dock',
  'doctor',
  'dog',
  'dogs',
  'doll',
  'dolls',
  'donkey',
  'door',
  'downtown',
  'drain',
  'drawer',
  'dress',
  'drink',
  'driving',
  'drop',
  'duck',
  'ducks',
  'dust',
  'ear',
  'earth',
  'earthquake',
  'edge',
  'education',
  'effect',
  'egg',
  'eggnog',
  'eggs',
  'elbow',
  'end',
  'engine',
  'error',
  'event',
  'example',
  'exchange',
  'existence',
  'expansion',
  'experience',
  'expert',
  'eye',
  'eyes',
  'face',
  'fact',
  'fairies',
  'fall',
  'fang',
  'farm',
  'fear',
  'feeling',
  'field',
  'finger',
  'fire',
  'fish',
  'flag',
  'flame',
  'flavor',
  'flight',
  'flock',
  'floor',
  'flower',
  'flowers',
  'fly',
  'fog',
  'fold',
  'food',
  'foot',
  'force',
  'fork',
  'form',
  'fowl',
  'frame',
  'friction',
  'friend',
  'friends',
  'frog',
  'frogs',
  'front',
  'fruit',
  'fuel',
  'furniture',
  'gate',
  'geese',
  'ghost',
  'giants',
  'giraffe',
  'glass',
  'glove',
  'gold',
  'government',
  'governor',
  'grade',
  'grain',
  'grape',
  'grass',
  'grip',
  'ground',
  'group',
  'growth',
  'guide',
  'guitar',
  'gun',
  'hair',
  'haircut',
  'hall',
  'hammer',
  'hand',
  'hands',
  'harbor',
  'harmony',
  'hat',
  'head',
  'health',
  'heat',
  'hill',
  'history',
  'hobbies',
  'hole',
  'holiday',
  'home',
  'honey',
  'hook',
  'hope',
  'horn',
  'horse',
  'horses',
  'hose',
  'hospital',
  'hot',
  'hour',
  'house',
  'houses',
  'humor',
  'hydrant',
  'ice',
  'icicle',
  'idea',
  'impulse',
  'income',
  'increase',
  'industry',
  'ink',
  'insect',
  'instrument',
  'insurance',
  'interest',
  'invention',
  'iron',
  'island',
  'jail',
  'jam',
  'jar',
  'jeans',
  'jelly',
  'jellyfish',
  'jewel',
  'join',
  'judge',
  'juice',
  'jump',
  'kettle',
  'key',
  'kick',
  'kiss',
  'kittens',
  'kitty',
  'knee',
  'knife',
  'knot',
  'knowledge',
  'laborer',
  'lace',
  'ladybug',
  'lake',
  'lamp',
  'land',
  'language',
  'laugh',
  'leather',
  'leg',
  'legs',
  'letter',
  'letters',
  'lettuce',
  'level',
  'library',
  'limit',
  'line',
  'linen',
  'lip',
  'liquid',
  'loaf',
  'lock',
  'locket',
  'look',
  'loss',
  'love',
  'low',
  'lumber',
  'lunch',
  'lunchroom',
  'machine',
  'magic',
  'maid',
  'mailbox',
  'marble',
  'mark',
  'market',
  'mask',
  'mass',
  'match',
  'meal',
  'measure',
  'meat',
  'meeting',
  'memory',
  'metal',
  'mice',
  'middle',
  'milk',
  'mind',
  'mine',
  'minister',
  'mint',
  'minute',
  'mist',
  'mitten',
  'money',
  'month',
  'moon',
  'morning',
  'mother',
  'motion',
  'mountain',
  'mouth',
  'move',
  'muscle',
  'name',
  'nation',
  'neck',
  'need',
  'needle',
  'nerve',
  'nest',
  'night',
  'noise',
  'north',
  'nose',
  'note',
  'notebook',
  'number',
  'nut',
  'oatmeal',
  'observation',
  'ocean',
  'offer',
  'office',
  'oil',
  'orange',
  'oranges',
  'order',
  'oven',
  'page',
  'pail',
  'pan',
  'pancake',
  'paper',
  'parcel',
  'part',
  'partner',
  'party',
  'passenger',
  'payment',
  'peace',
  'pear',
  'pen',
  'pencil',
  'person',
  'pest',
  'pet',
  'pets',
  'pickle',
  'picture',
  'pie',
  'pies',
  'pig',
  'pigs',
  'pin',
  'pipe',
  'pizzas',
  'place',
  'plane',
  'planes',
  'plant',
  'plantation',
  'plants',
  'plastic',
  'plate',
  'play',
  'playground',
  'pleasure',
  'plot',
  'plough',
  'pocket',
  'point',
  'poison',
  'pollution',
  'popcorn',
  'porter',
  'position',
  'pot',
  'potato',
  'powder',
  'power',
  'price',
  'produce',
  'profit',
  'property',
  'prose',
  'protest',
  'pull',
  'pump',
  'punishment',
  'purpose',
  'push',
  'quarter',
  'quartz',
  'question',
  'quicksand',
  'quiet',
  'quill',
  'quilt',
  'quince',
  'quiver',
  'rabbit',
  'rabbits',
  'rail',
  'railway',
  'rain',
  'rainstorm',
  'rake',
  'range',
  'rat',
  'rate',
  'ray',
  'reaction',
  'reading',
  'reason',
  'receipt',
  'recess',
  'record',
  'regret',
  'relation',
  'religion',
  'representative',
  'request',
  'respect',
  'rest',
  'reward',
  'rhythm',
  'rice',
  'riddle',
  'rifle',
  'ring',
  'rings',
  'river',
  'road',
  'robin',
  'rock',
  'rod',
  'roll',
  'roof',
  'room',
  'root',
  'rose',
  'route',
  'rub',
  'rule',
  'run',
  'sack',
  'sail',
  'salt',
  'sand',
  'scale',
  'scarecrow',
  'scarf',
  'scene',
  'scent',
  'school',
  'science',
  'scissors',
  'screw',
  'sea',
  'seashore',
  'seat',
  'secretary',
  'seed',
  'selection',
  'self',
  'sense',
  'servant',
  'shade',
  'shake',
  'shame',
  'shape',
  'sheep',
  'sheet',
  'shelf',
  'ship',
  'shirt',
  'shock',
  'shoe',
  'shoes',
  'shop',
  'show',
  'side',
  'sidewalk',
  'sign',
  'silk',
  'silver',
  'sink',
  'size',
  'skate',
  'skin',
  'skirt',
  'sky',
  'slave',
  'sleep',
  'sleet',
  'slip',
  'slope',
  'smash',
  'smell',
  'smile',
  'smoke',
  'snail',
  'snails',
  'snake',
  'snakes',
  'sneeze',
  'snow',
  'soap',
  'society',
  'sock',
  'soda',
  'sofa',
  'song',
  'songs',
  'sort',
  'sound',
  'soup',
  'space',
  'spade',
  'spark',
  'spiders',
  'sponge',
  'spoon',
  'spot',
  'spring',
  'spy',
  'square',
  'squirrel',
  'stage',
  'stamp',
  'star',
  'start',
  'statement',
  'station',
  'steam',
  'steel',
  'stem',
  'step',
  'stew',
  'stick',
  'sticks',
  'stitch',
  'stocking',
  'stomach',
  'stone',
  'stop',
  'store',
  'story',
  'stove',
  'stranger',
  'straw',
  'stream',
  'street',
  'stretch',
  'string',
  'structure',
  'substance',
  'sugar',
  'suggestion',
  'suit',
  'summer',
  'sun',
  'support',
  'surprise',
  'sweater',
  'swim',
  'swing',
  'system',
  'table',
  'tail',
  'talk',
  'tank',
  'taste',
  'tax',
  'teaching',
  'team',
  'teeth',
  'temper',
  'tendency',
  'tent',
  'territory',
  'test',
  'texture',
  'theory',
  'thing',
  'things',
  'thought',
  'thread',
  'thrill',
  'throat',
  'throne',
  'thumb',
  'thunder',
  'ticket',
  'tiger',
  'time',
  'tin',
  'title',
  'toad',
  'toe',
  'toes',
  'tomatoes',
  'tongue',
  'tooth',
  'toothbrush',
  'toothpaste',
  'top',
  'touch',
  'town',
  'toy',
  'toys',
  'trade',
  'trail',
  'train',
  'trains',
  'tramp',
  'transport',
  'tray',
  'treatment',
  'tree',
  'trees',
  'trick',
  'trip',
  'trouble',
  'trousers',
  'truck',
  'trucks',
  'tub',
  'turkey',
  'turn',
  'twig',
  'twist',
  'umbrella',
  'underwear',
  'unit',
  'use',
  'vacation',
  'value',
  'van',
  'vase',
  'vegetable',
  'veil',
  'vein',
  'verse',
  'vessel',
  'vest',
  'view',
  'visitor',
  'voice',
  'volcano',
  'volleyball',
  'voyage',
  'walk',
  'wall',
  'war',
  'wash',
  'waste',
  'watch',
  'water',
  'wave',
  'waves',
  'wax',
  'way',
  'wealth',
  'weather',
  'week',
  'weight',
  'wheel',
  'whip',
  'whistle',
  'wilderness',
  'wind',
  'window',
  'wine',
  'wing',
  'winter',
  'wire',
  'wish',
  'wood',
  'wool',
  'word',
  'work',
  'worm',
  'wound',
  'wren',
  'wrench',
  'wrist',
  'writer',
  'writing',
  'yak',
  'yam',
  'yard',
  'yarn',
  'year',
  'yoke',
  'zebra',
  'zephyr',
  'zinc',
  'zipper',
  'zoo'
]
